export default "__VITE_ASSET__DcUA66NA__"